<script setup lang="ts">
    import { __ } from '@/js/stores/expressions';
    import TextInput from '../TextInput.vue';
    import { useWidgetFormStore } from '@/js/stores/widgetForm';

    const formStore = useWidgetFormStore();
</script>
<template>
    <div class="flex flex-col gap-10">
        <div>
            <h1 class="text-lg font-semibold mb-1">
                {{ __('widget-form-name-input-title') }}
            </h1>
            <TextInput
                v-model="formStore.widget.title"
                name="title"
                :aria-label="__('widget-form-name-input-placeholder')"
                :placeholder="__('widget-form-name-input-placeholder')"
                :label="__('widget-form-name-input-label')"
                class="w-full"
            />
        </div>
        <div>
            <h1 class="text-lg font-semibold mb-1">
                {{ __('widget-form-description-input-title') }}
            </h1>
            <textarea
                v-model="formStore.widget.description"
                name="description"
                :placeholder="__('widget-form-description-input-placeholder')"
                :aria-label="__('widget-form-description-input-placeholder')"
                class="TextArea w-full h-30"
                rows="3"
            />
        </div>
    </div>
</template>
